var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"cat-stream-stream-fact-headline mb-2 blue-grey--text text--lighten-2"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }